module.exports = __webpack_public_path__ + "static/img/MDE_H5.021757b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MDE_H5.png
// module id = euaJ
// module chunks = 34